import * as React from 'react';

interface IUseKeyboardShortcuts {
  onEscape: () => void;
}
export const useOnEscape = ({ onEscape }: IUseKeyboardShortcuts): void => {
  React.useEffect(() => {
    const handleKeyboard = (event) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };
    document.addEventListener('keydown', handleKeyboard);
    return () => {
      document.removeEventListener('keydown', handleKeyboard);
    };
  }, [onEscape]);
};
